import Index from '../../pages/travel/superPunchClock/index';
import Query from '../../pages/travel/superPunchClock/query';

const base = 'superPunchClock';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/query*`,
    name: `${base}-query`,
    component: Query
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/travel/superPunchClock.js